const productPage = document.querySelector('.ex-product');
/**
 * Move logo to image
 */
const moveLogo = () => {
  const mainBrandLogo = document.querySelectorAll('.product-summary .product-brand');
  mainBrandLogo.forEach((item) => {
    item.closest('.catalog-single').querySelector('.main-image').append(item);
  });
};

/**
 * move breadcrumb into decription
 */
(() => {
  if (document.querySelector('.ex-product .row-breadcrumb')) {
    document.querySelector('.ex-product .mainproductpagedesktop .col-lg-10').prepend(document.querySelector('.ex-product .row-breadcrumb'));
  }
})();

/**
 * sales movement
 */
const appendRRP = () => {
  function appendElement(selector, targetSelector) {
    const element = document.querySelector(selector);
    if (element) {
      document.querySelector(targetSelector).append(element);
    }
  }

  appendElement('.product-shopping-actions-prices .product-price-rrp .rrp', '.product-shopping-actions-prices .uomvalue');
  appendElement('.mobile .product-shopping-actions-prices .product-price-rrp .rrp', '.mobile .product-shopping-actions-prices .uomvalue');
  appendElement('.product-shopping-actions-prices .product-price-rrp .save', '.product-shopping-actions-prices .price');
  appendElement('.mobile .product-shopping-actions-prices .product-price-rrp .save', '.mobile .product-shopping-actions-prices .price');

  const tierPricing = document.querySelectorAll('.product-shopping-actions-tierpricing');
  if (tierPricing.length > 0) {
    tierPricing.forEach((item) => {
      item.parentNode.classList.add('tier-pricing');
      item.parentNode.parentNode.classList.add('contains-tier-pricing');
    });
  }
};

/**
 * move details into tabs & functionality
 */
(() => {
  if (!productPage) return;
  const moveElement = (sourceSelector, destinationSelector) => {
    const sourceElement = document.querySelector(sourceSelector);
    if (sourceElement) {
      document.querySelector(destinationSelector).append(sourceElement);
    }
  };

  const resetTabs = (wrapperSelector) => {
    const allHeaders = document.querySelectorAll(`${wrapperSelector} .header h3`);
    const allBodies = document.querySelectorAll(`${wrapperSelector} .body > div`);

    allHeaders.forEach((header) => header.classList.remove('active'));
    allBodies.forEach((body) => body.classList.remove('active'));
  };

  const addTabListeners = (wrapperSelector, tabCount) => {
    for (let i = 1; i <= tabCount; i += 1) {
      const header = document.querySelectorAll(`${wrapperSelector} .header h3:nth-of-type(${i})`);

      header.forEach((item) => {
        item.addEventListener('click', () => {
          resetTabs(wrapperSelector);
          item.classList.add('active');
          const body = document.querySelectorAll(`${wrapperSelector} .body > div:nth-of-type(${i})`);
          body.forEach((bodyItem) => bodyItem.classList.add('active'));
        });
      });
    }
  };

  const prependInnerHTML = (sourceSelector, destinationSelector) => {
    const sourceElement = document.querySelector(sourceSelector);
    if (sourceElement) {
      const h3Element = sourceElement.querySelector('h3');
      if (h3Element) {
        const { innerHTML } = h3Element;
        document.querySelector(destinationSelector).prepend(innerHTML);
      }
    }
  };

  // move description & specs
  moveElement('.collapseDescription', '.tab-wrapper.specs .description-wrapper');
  moveElement('.collapseSpecs', '.tab-wrapper.specs .specifications-wrapper');
  moveElement('.mobile .collapseDescription', '.mobile .tab-wrapper.specs .description-wrapper');
  moveElement('.mobile .collapseSpecs', '.mobile .tab-wrapper.specs .specifications-wrapper');
  // click listeners
  addTabListeners('.tab-wrapper.specs', 4);

  // move recommended
  moveElement('.productsrelated_container .tab-one .griditems', '.tab-wrapper.recommended .body .tab-one-wrapper');
  prependInnerHTML('.productsrelated_container .tab-one', '.tab-wrapper.recommended .header .tab-one');
  moveElement('.productsrelated_container .tab-two .griditems', '.tab-wrapper.recommended .body .tab-two-wrapper');
  prependInnerHTML('.productsrelated_container .tab-two', '.tab-wrapper.recommended .header .tab-two');
  moveElement('.productsrelated_container .tab-three .griditems', '.tab-wrapper.recommended .body .tab-three-wrapper');
  prependInnerHTML('.productsrelated_container .tab-three', '.tab-wrapper.recommended .header .tab-three');
  // move mobile recommended
  moveElement('.mobile .productsrelated_container .tab-one .griditems', '.mobile .tab-wrapper.recommended .body .tab-one-wrapper');
  prependInnerHTML('.mobile .productsrelated_container .tab-one', '.mobile .tab-wrapper.recommended .header .tab-one');
  moveElement('.mobile .productsrelated_container .tab-two .griditems', '.mobile .tab-wrapper.recommended .body .tab-two-wrapper');
  prependInnerHTML('.mobile .productsrelated_container .tab-two', '.mobile .tab-wrapper.recommended .header .tab-two');
  moveElement('.mobile .productsrelated_container .tab-three .griditems', '.mobile .tab-wrapper.recommended .body .tab-three-wrapper');
  prependInnerHTML('.mobile .productsrelated_container .tab-three', '.mobile .tab-wrapper.recommended .header .tab-three');
  // click listeners
  addTabListeners('.tab-wrapper.recommended', 3);

  /**
 * Footer Intersection Observer for recommended tab
 */
  (() => {
    let currentActiveTab = 0;
    const changeActiveTab = (wrapperSelector, tabCount) => {
      const currentActiveHeader = document.querySelector(`${wrapperSelector} .header h3.active`);
      const currentActiveBody = document.querySelector(`${wrapperSelector} .body > div.active`);

      if (currentActiveHeader) currentActiveHeader.classList.remove('active');
      if (currentActiveBody) currentActiveBody.classList.remove('active');

      let newActiveHeader; let
        newActiveBody;
      let checkedTabs = 0;
      do {
        currentActiveTab = ((currentActiveTab) % tabCount) + 1;
        newActiveHeader = document.querySelector(`${wrapperSelector} .header h3:nth-of-type(${currentActiveTab})`);
        newActiveBody = document.querySelector(`${wrapperSelector} .body > div:nth-of-type(${currentActiveTab})`);
        checkedTabs += 1;
      } while (getComputedStyle(newActiveHeader).display === 'none' && checkedTabs < tabCount);

      if (getComputedStyle(newActiveHeader).display !== 'none') {
        if (newActiveHeader) newActiveHeader.classList.add('active');
        if (newActiveBody) newActiveBody.classList.add('active');
      }
    };

    // Call the function on initial load
    changeActiveTab('.tab-wrapper.recommended', 3);
    const footerObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setTimeout(changeActiveTab('.tab-wrapper.recommended', 3), 1000);
        }
      });
    });

    const footerElement = document.querySelector('footer');

    if (footerElement) {
      footerObserver.observe(footerElement);
    }
  })();
})();

/**
 * contact banner
 */
(() => {
  if (!productPage) return;

  const clonePhone = document.querySelector('.footer .contact-phone .contact-description p').cloneNode(true);
  const contactPhone = document.createElement('a');
  contactPhone.innerHTML = clonePhone.innerHTML;
  contactPhone.setAttribute('href', `tel: ${clonePhone.innerHTML}`);
  const contactEmail = document.querySelector('.footer .contact-email .contact-description p a').cloneNode(true);
  document.querySelector('.contact-banner .phone').append(contactPhone);
  document.querySelector('.contact-banner .email').append(contactEmail);
})();

/**
 * Product Indicators Wrap & Text
 */
const wrapProductIndicators = () => {
  document.querySelectorAll('.productdetails').forEach((product) => {
    let count = 0;
    product.querySelectorAll('.product-indicators > i').forEach((indicator) => {
      const title = indicator.getAttribute('data-original-title') || indicator.getAttribute('title');
      const indicatorWrap = document.createElement('div');
      indicatorWrap.className = 'indicator-wrap';
      indicatorWrap.append(indicator);
      indicatorWrap.insertAdjacentHTML('beforeend', `<span>${title}</span>`);
      product.querySelector('.product-indicators').append(indicatorWrap);
      count += 1;
    });
    if (count === 0) {
      const prodIndicator = product.querySelector('.product-indicators');
      if (!prodIndicator) return;

      prodIndicator.remove();
    }
  });
};

/**
 * Delivery text
 */
const deliveryText = () => {
  const pdp = document.querySelector('.ex-product');
  if (!pdp) return;

  const addDelivText = (str) => {
    const delivEle = document.createElement('div');
    delivEle.className = 'lead-time';

    delivEle.innerHTML = /* html */ `
      <img width="28px" src="https://eu.evocdn.io/dealer/1702/content/media/My_Theme/ex-icon-van.svg" />
      <span><strong>${str}</strong></span>`;

    document.querySelectorAll('.pdp-lead-time-dropship').forEach((item) => {
      item.append(delivEle.cloneNode(true));
    });
  };

  // data cusotmised in theme options - this is a fallback
  const leadTimeDefault = {
    1: 'Next Day Delivery',
    2: '2 Day Delivery',
    5: '3-5 Day Delivery',
    7: '7 Day Delivery',
    10: '10 Day Delivery',
    14: '14 Day Delivery',
    15: '10-15 Day Delivery',
    21: '21 Day Delivery',
    28: '21-28 Day Delivery',
    49: '42-49 Day Delivery',
    63: '63 Day Delivery',
  };

  // eslint-disable-next-line no-undef
  const leadTimeObj = (typeof leadTimeData === 'object') ? leadTimeData : leadTimeDefault;
  const leadTime = document.querySelector('.attr_item_lead_time .col-lg-8 p')?.textContent || 0;
  let delivText = 'Contact Us for Availability';

  if (leadTime) {
    Object.keys(leadTimeObj).forEach((key) => {
      if (key === leadTime) {
        delivText = leadTimeObj[key];
      }
    });
  }
  addDelivText(delivText);
};

/**
 * PDP Dropship
 */
const pdpDropship = () => {
  const pdp = document.querySelector('.ex-product');
  if (!pdp) return;

  // data cusotmised in theme options - this is a fallback
  const dropshipLabelsDefault = [
    '3463',
    '3447',
    '3448',
  ];

  // eslint-disable-next-line no-undef
  const dropShipArr = (typeof dropshipLabels === 'object') ? dropshipLabels : dropshipLabelsDefault;
  let isDropshop = false;

  dropShipArr.forEach((labelID) => {
    const bodyClass = `ex-l-${labelID}`;
    if (document.body.classList.contains(bodyClass)) {
      isDropshop = true;
    }
  });

  if (isDropshop) {
    const delivEle = document.createElement('div');
    delivEle.className = 'dropshop';

    delivEle.innerHTML = /* html */ `
      <img width="28px" src="https://eu.evocdn.io/dealer/1702/content/media/My_Theme/ex-icon-box.svg" />
      <span><strong>Dropship</strong></span>`;

    document.querySelectorAll('.pdp-lead-time-dropship').forEach((item) => {
      item.append(delivEle.cloneNode(true));
    });

    document.querySelectorAll('.productdetails .product-indicators').forEach((item) => {
      item.insertAdjacentHTML('afterbegin', /* html */`
        <div class="indicator-wrap">
          <img width="15px" src="https://eu.evocdn.io/dealer/1702/content/media/My_Theme/ex-icon-box.svg" />
          <span>Dropship</span>
        </div>
      `);
    });
  }
};

/**
 * Clone rebate text and link
 */
const cloneRebate = () => {
  const placementSelectors = document.querySelectorAll('.catalog-single .product-summary');

  const paragraphs = document.querySelectorAll('.desktop .product-description custom-html p');
  paragraphs.forEach((p) => {
    if (p.textContent.includes('Rebate')) {
      const newRebateText = document.createElement('span');
      newRebateText.className = 'rebate-text';
      newRebateText.textContent = p.textContent;
      placementSelectors.forEach((selector) => {
        selector.append(newRebateText.cloneNode(true));
      });
    }
  });

  const rebateLink = document.querySelector('.product-description a[href*="rebate"]');
  if (rebateLink) {
    const newRebateLink = document.createElement('a');
    newRebateLink.className = 'rebate-link nButton';
    newRebateLink.textContent = 'View Rebate Details';
    newRebateLink.href = rebateLink.href;
    newRebateLink.setAttribute('target', '_blank');
    newRebateLink.setAttribute('rel', 'noopener noreferrer');
    placementSelectors.forEach((selector) => {
      selector.append(newRebateLink.cloneNode(true));
    });
  }
};

/**
 * Move Manufacturer Ref
 */
(() => {
  const pdp = document.querySelector('.ex-product');
  if (!pdp) return;

  document.querySelectorAll('.productdetails').forEach((prodDetails) => {
    const manuRef = prodDetails.querySelector('.manufacturer-ref');
    const sku = prodDetails.querySelector('.prod-code');

    if (sku && manuRef) {
      sku.append(manuRef);
    }
  });
})();

const moveStock = () => {
  const inventory = document.querySelector('.productaddtocart_container .live-inventory-v2-wrapper');
  const summary = document.querySelector('.productsummary_container .productdetails');

  if (inventory && summary) {
    summary.append(inventory);
  }
};

const alternativeFunction = () => {
  const altLocation = document.querySelector('.productaddtocart_container .softgraybackground');
  if (!altLocation) return;

  const dataAlternateProduct = altLocation.getAttribute('data-erpalternateproduct');
  const inventoryOutStock = altLocation.querySelector('.live-inventory-v2-wrapper .out-stock');
  const addToCartButton = altLocation.querySelector('.live-inventory-v2-add-to-cart-wrapper button');
  if (dataAlternateProduct && inventoryOutStock && addToCartButton) {
    addToCartButton.textContent = 'See Alternatives';
  }
};

const pdpInitFunctions = () => {
  moveLogo();
  wrapProductIndicators();
  appendRRP();
  // deliveryText();
  // pdpDropship();
  cloneRebate();
  moveStock();
};

/**
 * init
 */
(() => {
  const query = document.querySelector('.ex-product');
  if (!query) return;

  pdpInitFunctions();

  document.addEventListener('live-pricing-done', () => {
    alternativeFunction();
  }, false);
})();

window.evoXProductChangeCallback = () => {
  pdpInitFunctions();
};

/**
 * PDP wrap filters
 */
(() => {
  const query = document.querySelectorAll('.ex-product .filter-container');
  if (!query.length) return;

  query.forEach((item) => {
    item.innerHTML = /* html */ `
      <div class="filter-wrap">
       ${item.innerHTML}
      </div>
    `;
  });
})();

/**
 * make pdp iframe scrollable. Prevents long iframe from breaking layout
 */
(() => {
  const query = document.querySelector('.ex-product .product-description iframe');
  if (!query) return;

  query.setAttribute('scrolling', 'yes');
})();
